"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var language_picker_html_1 = __importDefault(require("./language-picker.html"));
require("./language-picker.less");
(function (module) {
    'use strict';
    function languagePickerController($scope, $filter, $sanitize, navigationService, EVENTS, stream, dynamicTranslationsUtil) {
        var $ctrl = this;
        $scope.$ctrl = $ctrl;
        /**
         * Gets the default language, list of available language codes
         * and event listeners
         */
        function initLanguagePicker() {
            dynamicTranslationsUtil.getDefaultLanguageCode($ctrl.languageCode).then(function (languageCode) {
                $ctrl.languageCode = $sanitize(languageCode);
            });
            if ($ctrl.useCachedLanguagesOnInit) {
                $ctrl.availableLanguageCodes = dynamicTranslationsUtil.getCachedAvailableLanguageCodes();
            }
            else {
                dynamicTranslationsUtil.getAvailableLanguageCodes().then(function (availableLanguageCodes) {
                    $ctrl.availableLanguageCodes = availableLanguageCodes;
                });
            }
            stream.on('dynamicTranslationsUpdated', getAvailableLanguages);
        }
        /**
         * For a report, gets all the sources tied to the report and unions their list of enabled languages
         * @return {Array<String>} languageCodes - a list of unique language codes
         */
        function getAvailableLanguages() {
            return dynamicTranslationsUtil.getAvailableLanguageCodes().then(function (availableLanguageCodes) {
                $ctrl.availableLanguageCodes = availableLanguageCodes;
                var languages = translateLanguageCodes($ctrl.availableLanguageCodes);
                return _.map(languages, function (lang, index) {
                    return {
                        label: lang.language,
                        value: index,
                        selected: $ctrl.languageCode === lang.languageCode
                    };
                });
            });
        }
        /**
         * Converts language codes to human readable.
         * Langugage translations are prefixed By `Language.`
         *
         * @param {Array} languageCodes
         * @return {Array} language strings
         */
        function translateLanguageCodes(languageCodes) {
            var TRANSLATION_NAMESPACE = 'Language.';
            if (!_.isArray(languageCodes)) {
                languageCodes = [languageCodes];
            }
            return _.map(languageCodes, function (languageCode) {
                return {
                    languageCode: languageCode,
                    language: $ctrl.translate(TRANSLATION_NAMESPACE + languageCode)
                };
            });
        }
        /**
         * Checks that the user selected language is contained in list of availableLanguageCodes
         * @param {Number} langIdx
         */
        function isLangIdxValid(langIdx) {
            return !_.isNaN(langIdx) && langIdx >= 0 && langIdx < $ctrl.availableLanguageCodes.length;
        }
        /**
         * Trigger a widget refresh unless disableInteraction is true.
         * disableInteraction is set to true for scheduled emails language picker
         * because we don't want the dropdown to trigger a change in the report language.
         */
        function reloadWidgets() {
            if (!$ctrl.disableInteraction) {
                dynamicTranslationsUtil.updateLanguageCode($ctrl.languageCode);
            }
        }
        // functions available to the view
        angular.extend($ctrl, {
            getAvailableLanguages: getAvailableLanguages,
            translateLanguageCodes: translateLanguageCodes,
            $onInit: function () {
                $ctrl.isPublic = navigationService.isPublic;
                $ctrl.isPreview = navigationService.isPreview;
                $ctrl.usesPublicToolbar = $ctrl.isPublic || $ctrl.isPreview;
                $ctrl.translate = $filter('translate');
                initLanguagePicker();
            },
            selectLanguage: function (langIdx) {
                /**
                 * Handles the logic for selection in the  menu dropdown
                 */
                langIdx = _.toNumber(langIdx);
                if (isLangIdxValid(langIdx)) {
                    $ctrl.languageCode = $ctrl.availableLanguageCodes[langIdx];
                }
                else {
                    $ctrl.languageCode = dynamicTranslationsUtil.getDefaultContainerLanguageCode();
                }
                reloadWidgets();
                if ($ctrl.setLanguageCode) {
                    $ctrl.setLanguageCode()($ctrl.languageCode);
                }
                stream.trigger(EVENTS.REPORT_LANGUAGE_CHANGED);
            }
        });
    }
    languagePickerController.$inject = [
        '$scope',
        '$filter',
        '$sanitize',
        'pr.navigationService',
        'pr.EVENTS',
        'prEventService',
        'prDynamicTranslationsUtil'
    ];
    module.component('prLanguagePicker', {
        templateUrl: language_picker_html_1.default,
        controller: languagePickerController,
        bindings: {
            /**
             * boolean - if true, then we don't cause the report to reload
             * with the given language.
             */
            disableInteraction: '<',
            /**
             * string - language code from parent component.
             */
            languageCode: '<?',
            /**
             * function - callback to set the parent component language.
             */
            setLanguageCode: '&?',
            /**
             * If true, then check the cache first before
             * making a network request to get available language codes.
             */
            useCachedLanguagesOnInit: '<?',
            /**
             * boolean - used for toolbar component css styling.
             */
            isToolbar: '<?',
        }
    });
}(angular.module('qualtrics.pr')));
